import { Svg } from "common/assets";
import {
  IconLogo,
  StyledSpan,
  StyledSpanTitle,
  StyledSpanTitleMiddle,
  StyledTitleWrapper,
} from "./styled";
import { Fade } from "react-awesome-reveal";

export const TitleHero = () => {
  return (
    <StyledTitleWrapper>
       <Fade
          cascade
          triggerOnce
          direction="left"
          delay={200}
          duration={400}
          damping={0.5}
        >
      <StyledSpanTitle>Справжнє</StyledSpanTitle>
      <StyledSpanTitleMiddle>
        <StyledSpan>євр</StyledSpan>
        <StyledSpan>
          <IconLogo src={Svg.LogoHero} />
        </StyledSpan>
        <StyledSpan>пейське</StyledSpan>
      </StyledSpanTitleMiddle>
        <StyledSpanTitle>пальне</StyledSpanTitle>
        </Fade>
    </StyledTitleWrapper>
  );
};
